// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__28xDA","tab":"Tabs_tab__EorTx","tabActive":"Tabs_tabActive__3HJI9"};